/* eslint-disable */
<template>
  <section class='content'>
    <div class='container-fluid'>
      <div class='block-header'>
        <h2>{{ nama }}</h2>
      </div>
      <div class='row clearfix'>
        <div class='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
          <div class='card'>
            <div class='header'>
              <h2>{{ id_Pengaduan != null ? 'Edit' : 'Tambah' }} {{ nama }}</h2>
            </div>
            <div class='body'>
              <form class='form-horizontal' v-on:submit.prevent='onSubmit'>
                <div class='row clearfix'>
                  <div
                    class='col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label'
                  >
                    <label for='judul'>deskripsi</label>
                  </div>
                  <div class='col-lg-10 col-md-10 col-sm-8 col-xs-7'>
                    <div class='form-group'>
                      <form-line
                        id='judul'
                        type='text'
                        v-model='data.deskripsi'
                        :disabled="true"
                      ></form-line>
                    </div>
                  </div>
                </div>
                <div class='row clearfix'>
                  <div
                    class='col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label'
                  >
                    <label for='Topik'>Topik</label>
                  </div>
                  <div class='col-lg-10 col-md-10 col-sm-8 col-xs-7'>
                    <div class='form-group'>
                      <form-line
                        id='Topik'
                        type='text'
                        v-model='data.topik'
                        :disabled="true"
                      ></form-line>
                    </div>
                  </div>
                </div>
                <div class='row clearfix'>
                  <div
                    class='col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label'
                  >
                    <label for='penulis'>Jawaban</label>
                  </div>
                  <div class='col-lg-10 col-md-10 col-sm-8 col-xs-7'>
                    <div class='form-group'>
                      <form-line
                        id='penulis'
                        type='text'
                        v-model='data.jawaban'
                      ></form-line>
                    </div>
                  </div>
                </div>
                <div class='row clearfix'>
                  <div
                    class='col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5'
                  >
                    <button
                      v-if='id_Pengaduan != null'
                      @click='update'
                      type='button'
                      class='btn btn-warning waves-effect waves-button'
                      v-bind:disabled='isLoading'
                      v-waves.button
                    >
                      <i v-if='isLoading' class='fa fa-spin fa-spinner'></i
                      ><i v-if='!isLoading' class='material-icons'>save</i> Edit
                    </button>
                    <button
                      v-else
                      @click='save'
                      type='button'
                      class='btn btn-primary waves-effect waves-button'
                      v-bind:disabled='isLoading'
                      v-waves.button
                    >
                      <i v-if='isLoading' class='fa fa-spin fa-spinner'></i
                      ><i v-if='!isLoading' class='material-icons'>save</i>
                      Simpan
                    </button>
                    <button
                      @click='$router.go(-1)'
                      type='button'
                      class='btn btn-danger'
                      v-waves.button
                    >
                      <i class='material-icons'>cancel</i> Batal
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */

import Ckeditor from 'vue-ckeditor2'
import FormLine from '@/components/FormLine.vue'
import api from '@/helper/api'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'

export default {
  components: { FormLine, Ckeditor, vueDropzone: vue2Dropzone },
  name: 'Pengaduan',
  data: function () {
    return {
      data: {
        deskripsi: '',
        nama:'',
        nip:'',
        keterangan:'',
        statusTiket:'Pengajuan selesai',
        jawaban:'',
      },
      tanggal: '',
      id_Pengaduan: '',
      nama: '',
      link: '',
      isLoading: false,
      init: false
    }
  },
  methods: {

    update () {
      this.isLoading = true
      api.defaults.headers.common['Authorization'] =
        'Bearer ' + localStorage.getItem('_token')
        console.log("ini datanya",this.data)
      api
        .post('/updateTiket/' + this.id_Pengaduan, this.data)
        .then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/informasi/' + this.link)
            this.$toastr.s('Ubah data berhasil')
          }
          this.isLoading = false
        })
        .catch((e) => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
    }, 
    getDetail () {
  this.init = true
  api.defaults.headers.common['Authorization'] =
    'Bearer ' + localStorage.getItem('_token')

  api
    .get('/pengaduanGetbyId/' + this.id_Pengaduan)
    .then((result) => {
      const res = result.data.object
      this.data.deskripsi = res.deskripsi || ''
      this.data.nama = res.nama || ''
      this.data.nip = res.nip || ''
      this.data.noTiket = res.noTiket || ''
      this.data.keterangan = res.keterangan || ''
      this.data.topik = res.topik||''
      this.data.jawaban = res.jawaban||''
      this.data.topikId = res.topikId || ''
    })
    .catch((ex) => {
      console.error("Error getDetail:", ex)
      this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
      this.init = false
    })
}
,
    onSubmit () {
      if (this.id_Pengaduan != null) this.update()
      else this.save()
    },
    checkRoute (route) {
      console.log(route.name)
      if (route.name === 'EditPengaduan' || route.name === 'EditPengaduan') {
        this.link = 'Pengaduan'
        this.nama = 'Pengaduan'
      }
    },
    vremoved (file, xhr, error) {
      console.log("ini filenya", file)
      if (!this.init) this.delete(file.name.id)
    },
    delete (id) {
      api.defaults.headers.common['Authorization'] =
        'Bearer ' + localStorage.getItem('_token')
      api
        .delete('/delete_file_Pengaduan/' + id)
        .then((result) => {
          console.log(result.data.code)
          if (result.data.code === 200) {
            this.$toastr.s('Foto berhasil dihapus')
            this.$swal.close()
          } else {
            this.$toastr.e('Gagal menghapus foto')
            this.$swal.close()
          }
        })
        .catch((e) => {
          this.$swal.close()
        })
    }
  },
  mounted () {
    this.checkRoute(this.$route)
    this.id_Pengaduan = this.$route.params.id
    if (this.id_Pengaduan != null) {
      this.getDetail()
    }
  },
  watch: {
    $route (to, from) {
      this.checkRoute(to)
    },
    'data.content'(newVal) {
      console.log('Konten Pengaduan berubah')
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/view/Pengaduan/Pengaduan.vue?bce03f86